import type { CSSProperties } from 'react';
import type { BoxLayout, ComponentMetaInput } from '../../ui';

const PAGE = 'billing';
export const BILLING_COMPONENTS: ComponentMetaInput[] = [
  { id: 'billing.root', page: PAGE, role: 'container', label: '充值页', layout: { x: 0, y: 24, width: 390, height: 744 }, zIndex: 1, notes: '安卓用 Fragment 根容器；内容可滚动' },
  { id: 'billing.header', page: PAGE, role: 'container', label: '充值页头部', layout: { x: 0, y: 24, width: 390, height: 56 }, zIndex: 2, notes: '安卓用 MaterialToolbar' },
  { id: 'billing.title', page: PAGE, role: 'text', label: '充值标题', layout: { x: 16, y: 36, width: 300, height: 32 }, zIndex: 3, notes: '安卓用 Toolbar 标题 TextView' },
  { id: 'billing.form', page: PAGE, role: 'container', label: '充值表单', layout: { x: 16, y: 96, width: 358, height: 280 }, zIndex: 2, notes: '安卓用 CardView 表单容器' },
  { id: 'billing.pay.wxpay', page: PAGE, role: 'button', label: '微信支付', layout: { x: 32, y: 280, width: 155, height: 48 }, zIndex: 3, notes: '安卓用 MaterialButton；点击以 paymentType=wxpay 创建订单，服务端将 type=wxpay 加入现有 RSA 签名后同页跳转 checkout；不修改管理默认配置' },
  { id: 'billing.pay.alipay', page: PAGE, role: 'button', label: '支付宝支付', layout: { x: 203, y: 280, width: 155, height: 48 }, zIndex: 3, notes: '安卓用 MaterialButton；点击以 paymentType=alipay 创建订单，服务端将 type=alipay 加入现有 RSA 签名后同页跳转 checkout；不修改管理默认配置' },
  { id: 'billing.orders', page: PAGE, role: 'list', label: '充值订单列表', layout: { x: 16, y: 392, width: 358, height: 300 }, zIndex: 2, notes: '安卓用 RecyclerView；显示支付状态' },
  { id: 'billing.notice', page: PAGE, role: 'text', label: '充值状态提示', layout: { x: 16, y: 96, width: 358, height: 72 }, zIndex: 3, notes: '安卓用 TextView；显示登录或支付状态' },
];

export function billingMeta(id: string): ComponentMetaInput {
  const found = BILLING_COMPONENTS.find((meta) => meta.id === id);
  if (found === undefined) throw new Error(`[billing] 未登记的部件：${id}`);
  return found;
}

export function contentStyle(layout: BoxLayout): CSSProperties {
  return { position: 'absolute', left: layout.x, top: layout.y - 24, width: layout.width, height: layout.height };
}
